<template>
  <section class="row align-items-center">
    <div class="col-lg-6">
      <img :src="subImage?subImage.url:''" alt="" class="img-fluid w-100 w-lg-auto mb-3 mb-lg-0">
    </div>
    <div class="col-lg-6" v-html="subDescription">
    </div>
  </section>
</template>
<script setup>
import { defineProps } from 'vue';
  defineProps({
    subDescription: {
      type: String,
      required: true,
    },
    subImage: {
      type: Object,
      required: true,
    },
  });
</script>